import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { HubBrief, HubListFacade, HubListSearchCriteria, LoadingFacade } from '../../../../../store';
import { ListQueryParam } from '../../../../../common/constants/list-query-param.constant';
import { ListRange } from '../../../../../common/models/list.model';
import { ListServerPagination, ListServerPaginationStateModel } from '../../../../../common';
import { ActionButtonComponent, ButtonAction, ButtonType } from '../../../../action-button';
import { FilterSearch, FilterSettings, ListFilterComponent } from '../../../../list-filter';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HubSelectionItem } from '../../../../../container-components/hubs-selection/models';
import { DirectivesModule } from '../../../../../common/directives/directives.module';

@Component({
  selector: 'lib-hubs-filter-dialog',
  templateUrl: './hubs-filter-dialog.component.html',
  styleUrls: ['./hubs-filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatDialogModule,
    MatPaginatorModule,
    MatTableModule,
    MatRadioModule,
    TranslateModule,
    DirectivesModule,
    ListFilterComponent,
    ActionButtonComponent,
  ],
})
export class HubsFilterDialogComponent
  extends ListServerPagination<HubBrief>
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns = ['select', 'name', 'ssccId'];
  listDto$: Observable<ListServerPaginationStateModel<HubBrief>>;
  filterConfig: FilterSettings;
  searchCriteriaValue: HubListSearchCriteria = new HubListSearchCriteria();
  buttonAction = ButtonAction;
  buttonType = ButtonType;
  selectedRows = new HubBrief();
  hasValue$ = new BehaviorSubject<boolean>(false);

  constructor(
    translateService: TranslateService,
    public dialogRef: MatDialogRef<HubsFilterDialogComponent>,
    public hubListFacade: HubListFacade,
    public loadingFacade: LoadingFacade,
    @Inject(MAT_DIALOG_DATA) public data: HubSelectionItem[],
  ) {
    super(translateService);
    this.listDto$ = hubListFacade.listDto$;
  }

  ngOnInit(): void {
    this.initFiltersForm();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnDestroy(): void {
    this.hubListFacade.setInitialState();
  }

  fetchList(listRange: ListRange): void {
    timer(0)
      .pipe(take(1))
      .subscribe(() => {
        this.searchCriteriaValue = {
          ...this.searchCriteriaValue,
          ...listRange,
        };
        this.hubListFacade.loadListForDialog(new HubListSearchCriteria(this.searchCriteriaValue));
      });
  }

  fetchListBySearchCriteria(filterValue?: HubListSearchCriteria): void {
    if (filterValue) {
      this.searchCriteriaValue = {
        ...this.searchCriteriaValue,
        ...filterValue,
        page: 0,
      };
    } else {
      this.searchCriteriaValue = {
        ...this.searchCriteriaValue,
        page: 0,
      };
    }
    this.hubListFacade.loadListForDialog(new HubListSearchCriteria(this.searchCriteriaValue));
  }

  noHubsExist(): boolean {
    return !this.searchCriteriaValue[ListQueryParam.Filter] && this.dataSource && this.dataSource.data.length === 0;
  }

  confirm(): void {
    this.dialogRef.close(this.selectedRows);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  toggle(row: HubBrief): void {
    this.selectedRows = row;
  }

  private initFiltersForm(): void {
    this.filterConfig = {
      items: [new FilterSearch({ name: ListQueryParam.Filter })],
    };
  }
}
